import { render, staticRenderFns } from "./SamDataTable.vue?vue&type=template&id=f0ee86e2&scoped=true&shadow"
import script from "./SamDataTable.vue?vue&type=script&lang=js&shadow"
export * from "./SamDataTable.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./SamDataTable.vue?vue&type=style&index=0&id=f0ee86e2&prod&scoped=true&lang=scss&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "f0ee86e2",
  null
  ,true
)

export default component.exports